var React = require('react');

function BluelineBot2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M379.631 64.7574C643.128 63.371 789.514 62.6007 800 0V71V81H0V71C145.18 65.991 272.148 65.3229 379.631 64.7574Z","fill":"#3290FF"}));
}

BluelineBot2.defaultProps = {"width":"800","height":"81","viewBox":"0 0 800 81","preserveAspectRatio":"none","fill":"none"};

module.exports = BluelineBot2;

BluelineBot2.default = BluelineBot2;
